var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.onFavoritesRoute),expression:"onFavoritesRoute"}]},[_c('Grid',{attrs:{"providers":_vm.providers,"games":_vm.games}})],1),_c('v-fade-transition',{attrs:{"hide-on-leave":true}},[_c('router-view',{attrs:{"providers":_vm.providers,"games":_vm.games}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }